import { render, staticRenderFns } from "./VuesticFileUploadContainer.vue?vue&type=template&id=23bb1f3e"
import script from "./VuesticFileUploadContainer.vue?vue&type=script&lang=js"
export * from "./VuesticFileUploadContainer.vue?vue&type=script&lang=js"
import style0 from "./VuesticFileUploadContainer.vue?vue&type=style&index=0&id=23bb1f3e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23bb1f3e')) {
      api.createRecord('23bb1f3e', component.options)
    } else {
      api.reload('23bb1f3e', component.options)
    }
    module.hot.accept("./VuesticFileUploadContainer.vue?vue&type=template&id=23bb1f3e", function () {
      api.rerender('23bb1f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-file-upload/VuesticFileUploadContainer.vue"
export default component.exports